import React, { createContext, useReducer, useEffect } from 'react';

// Initial state for the application
const initialState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    cart: [],
    products: [],
    theme: "light", // Example of a global property
};

// Reducer function to manage state updates
const appReducer = (state, action) => {
     switch (action.type) {
         case 'LOGIN_START':
           return { ...state, loading: true, error: null };
         case 'LOGIN_SUCCESS':
           return { ...state, loading: false, user: action.payload.user, isAdmin: action.payload.isAdmin, session: action.payload.session, error: null };
         case 'LOGIN_FAILURE':
           return { ...state, loading: false, user: null, token: null, error: action.payload };
         case 'LOGOUT':
           return { ...state, user: null, session: null };
          case 'SET_USER':
             return { ...state, user: action.payload.user, session: action.payload.session }
           case "ADD_TO_CART":
           return { ...state, cart: [...state.cart, action.payload] };
           case "SET_PRODUCTS":
           return { ...state, products: action.payload };
           case "TOGGLE_THEME":
           return { ...state, theme: state.theme === "light" ? "dark" : "light" };
         default:
           throw new Error(`Unhandled action type: ${action.type}`);
     }
};

// Create the global context
export const AppContext = createContext();

// Context Provider Component
export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    useEffect(() => {
     const storedUser = localStorage.getItem('user');
       if (storedUser) {
       try{
             const parsedUser = JSON.parse(storedUser);
             dispatch({ type: 'SET_USER', payload: parsedUser});
         }catch(e){
            console.log('Error parsing the stored user in localstorage')
         }
       }
   }, [dispatch]);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};